import {Checkbox} from "antd";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setWeekFilters} from "../../../../store/actions";

const WEEKS_AMOUNT = 4;

const WeekFilters = ({ defaultWeek }) => {

    const dispatch = useDispatch();

    const currentWeekNumber = useSelector(state => state.schedule.currentWeekNumber);
    const weekFilters = useSelector(state => state.schedule.weekFilters);

    useEffect(() => {
        if (!defaultWeek) return;

        const tmp = Array(WEEKS_AMOUNT).fill(false);
        tmp[defaultWeek - 1] = true;
        dispatch(setWeekFilters(tmp));
    }, [dispatch, defaultWeek]);

    const selectWeekHandler = (value, index) => {
        const tmp = [...weekFilters];
        tmp[index] = value.target.checked;
        dispatch(setWeekFilters(tmp));
    }

    const selectAllWeeksHandler = (value) => {
        const tmp = Array(WEEKS_AMOUNT).fill(value);
        tmp[currentWeekNumber - 1] = true;
        dispatch(setWeekFilters(tmp));
    }

    const weekFiltersArray = [];
    for (let i = 0; i < 4; i++) {
        weekFiltersArray.push(
            <Checkbox
                key={`week${i}`}
                checked={weekFilters[i]}
                onChange={(e) => selectWeekHandler(e, i)}
                style={{ whiteSpace: 'nowrap' }}>
                {`${i + 1} ${((i + 1) === currentWeekNumber) ? '(текущая)' : ''}`}
            </Checkbox>);
    }
    weekFiltersArray.push(<Checkbox
        key="weekAll"
        checked={weekFilters.every(weekState => weekState === true)}
        onChange={(e) => selectAllWeeksHandler(e.target.checked)}>
        Все
    </Checkbox>);

    return weekFiltersArray;
}

export default WeekFilters;